import { render, staticRenderFns } from "./employment-doc-zoom.vue?vue&type=template&id=2c13ea70&"
import script from "./employment-doc-zoom.vue?vue&type=script&lang=js&"
export * from "./employment-doc-zoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports